import { defineMessages } from 'react-intl';

//main route
const electronicPurseScope = 't.page.ElectronicPurse';

//routes
const electronicPurseCouponDetailtScope = 't.page.ElectronicPurse.route.couponDetail';
const electronicPurseCouponManagementScope = 't.page.ElectronicPurse.route.couponManagement';

//errors
const globalErrorsScope = 't.global.error';

//global
const globalScope = 't.global';

export default defineMessages({
	pageTitle: {
		id: `${electronicPurseScope}.pageTitle`,
	},
	cdPageTitle: {
		id: `${electronicPurseCouponDetailtScope}.pageTitle`,
	},
	ccmPageTitle: {
		id: `${electronicPurseCouponManagementScope}.couponCreation.pageTitle`,
	},
	ccmPageSubtitle: {
		id: `${electronicPurseCouponManagementScope}.couponCreation.pageSubtitle`,
	},
	cemPageTitle: {
		id: `${electronicPurseCouponManagementScope}.couponEditing.pageTitle`,
	},
	epurseCode: {
		id: `${electronicPurseScope}.epurseCode`,
	},
	epurseName: {
		id: `${electronicPurseScope}.name`,
	},
	merchantId: {
		id: `${electronicPurseScope}.merchant`,
	},
	amountFrom: {
		id: `${electronicPurseScope}.amountFrom`,
	},
	amountTo: {
		id: `${electronicPurseScope}.amountTo`,
	},
	dateFrom: {
		id: `${electronicPurseScope}.dateFrom`,
	},
	dateTo: {
		id: `${electronicPurseScope}.dateTo`,
	},
	username: {
		id: `${electronicPurseScope}.username`,
	},
	userId: {
		id: `${electronicPurseScope}.userId`,
	},
	creationDate: {
		id: `${electronicPurseScope}.creationDate`,
	},
	cardType: {
		id: `${electronicPurseScope}.cardType`,
	},
	merchant: {
		id: `${electronicPurseScope}.merchant`,
	},
	spendability: {
		id: `${electronicPurseScope}.spendability`,
	},
	amount: {
		id: `${electronicPurseScope}.amount`,
	},
	name: {
		id: `${electronicPurseScope}.name`,
	},
	target: {
		id: `${electronicPurseScope}.target`,
	},
	typeGiftCard: {
		id: `${electronicPurseScope}.typeGiftCard`,
	},
	typeElectronicPurse: {
		id: `${electronicPurseScope}.typeElectronicPurse`,
	},
	successfullyDelete: {
		id: `${electronicPurseScope}.successfullyDelete`,
	},
	failureDelete: {
		id: `${electronicPurseScope}.failureDelete`,
	},
	deleteSubtitle: {
		id: `${electronicPurseScope}.deleteSubtitle`,
	},
	createCoupon: {
		id: `${electronicPurseScope}.createCoupon`,
	},
	3: {
		id: `${electronicPurseScope}.cardTypeElectronicPurse`,
	},

	invalidEmail: {
		id: `${globalErrorsScope}.invalidEmail`,
	},
	maxLength: {
		id: `${globalErrorsScope}.maxLength`,
	},
	invalidDate: {
		id: `${globalErrorsScope}.invalidDate`,
	},
	fieldRequested: {
		id: `${globalErrorsScope}.fieldRequested`,
	},
	theSecondDateIsMinorThanFirst: {
		id: `${globalErrorsScope}.theSecondDateIsMinorThanFirst`,
	},
	theSecondAmountIsMinorThanFirst: {
		id: `${globalErrorsScope}.theSecondAmountIsMinorThanFirst`,
	},
	fillFirstDateToContinueValidation: {
		id: `${globalErrorsScope}.fillFirstDateToContinueValidation`,
	},
	dateCantBeMinorOrEqualThanToday: {
		id: `${globalErrorsScope}.dateCantBeMinorOrEqualThanToday`,
	},
	maxAmount: {
		id: `${globalErrorsScope}.maxAmount`,
	},

	// Global Scope
	abortLabelButton: {
		id: `${globalScope}.abort`,
	},
	createLabelButton: {
		id: `${globalScope}.create`,
	},
	saveLabelButton: {
		id: `${globalScope}.save`,
	},
	warningTitle: {
		id: `${globalScope}.warning`,
	},
	confirmLabelButton: {
		id: `${globalScope}.confirm`,
	},
	subtitleDelete: {
		id: `${globalScope}.subtitleDelete`,
	},
	downloadReportXLS: {
		id: `${globalScope}.reportXls`,
	},
	edit: {
		id: `${globalScope}.edit`,
	},
	currency: {
		id: `${globalScope}.currency`,
	},
	showDate: {
		id: `${globalScope}.showDate`,
	},
	data: {
		id: `${globalScope}.data`,
	},
	externalId: {
		id: `${globalScope}.externalId`,
	},
	group: {
		id: `${globalScope}.group`,
	},
});
